const routes = [
  {
    path: '',
    name: '',
    component: () => import('@/views/provider/compensatoryService/Wrapper.vue'),
    children: [
      {
        path: '/provider/compensatoryservice',
        name: 'Main',
        component: () =>
          import('@/views/provider/compensatoryService/Main.vue'),
      },
      {
        path: '/provider/compensatoryservice/searchservice',
        name: 'CompensatorySearchService',
        component: () =>
          import(
            '@/views/provider/compensatoryService/SearchServiceWrapper.vue'
          ),
      },
      {
        path: '/provider/compensatoryservice/request',
        name: 'CompensatoryRequest',
        component: () =>
          import('@/views/provider/compensatoryService/RequestWrapper.vue'),
      },
      {
        path: '/provider/compensatoryservice/closinganalysis/:id',
        name: 'ClosingAnalysis',
        component: () =>
          import('@/views/provider/compensatoryService/ClosingAnalysis.vue'),
      },
      {
        path: '/provider/compensatoryservice/StatusHistory/:id',
        name: 'CompensatoryRequestStatusHistory',
        component: () =>
          import('@/views/provider/compensatoryService/StatusHistory.vue'),
      },
      {
        path: '',
        component: () =>
          import('@/views/provider/visitRegistry/VisitWrapper.vue'),
        children: [
          {
            path: '/provider/visitRegistry/validateVisit',
            name: 'compensatoryVisitRegistryValidate',
            component: () =>
              import('@/views/provider/visitRegistry/VisitValidation.vue'),
          },
        ],
      },
    ],
  },
];
export default routes;
